import { Box, Hidden, IconButton, Tooltip, Typography } from "@mui/material"
import { useStyles } from "./styles"
import { useTranslation } from "react-i18next"
import { VisitListProps } from "./types"
import Visite from "../visite"
import { ActionDrawer } from "../../../../../../components/ActionDrawer"
import { icons } from "../../../../../../utils/icons"
import { BosySecton } from "../bodySection"
import { useMutation } from "@tanstack/react-query"
import { scheduleServiceFetch } from "../../../../../../utils/constants/callService"
import { emitEvent } from "../../../../../../hooks/emitter"
import { EventQuery, Events, queryClient } from "../../../../../../hooks/emitter/types"
import { Status, Types } from "../../../../../../utils/enums"
import { useMemo } from "react"
import { useParams } from "react-router-dom"
import { LoadingButton } from "@mui/lab"
import { TypeOfQuestionarie } from "../../../../../../utils/enums/typeQuestionarie"

const VisitList = ({ seeDetail, isStore, from, to, visitList = [], bodySection }: VisitListProps) => {
    const { id } = useParams()
    const { t } = useTranslation()
    const styles = useStyles()
    const closeQuestionnaire = useMemo(() => [Status.ACTIVE, Status.EXPIRED, Status.STARTED, Status.INCOMPLETE].includes(bodySection.status), [bodySection.status])
    const emits = useMemo(() => ({
        success: ({ message }: { message: string }) => { emitEvent(Events.snackbar, { open: true, type: Types.SUCCESS, message }) },
        error: ({ message }: { message: string }) => { emitEvent(Events.snackbar, { open: true, type: Types.ERROR, message }) },
        close: () => { emitEvent(Events.modal_close) },
        loading: ({ value }: { value: boolean }) => { emitEvent(Events.modal_extra, { loading: value }) },
    }), [])

    const deleteSchedule = useMutation({
        mutationFn: scheduleServiceFetch.deleteScheduleQuestionnaire,
        onSuccess: (data) => {
            emits.close()
            if (data?.errors?.length) {
                emits.error({ message: t('schedule.deleteQuestionnaire.error') })
                return
            }
            const typeName = bodySection?.typeOfQuestionnaire == TypeOfQuestionarie.BYUSER ? EventQuery.user_schedule : EventQuery.unit_schedule
            queryClient.invalidateQueries({
                queryKey: [typeName],
                type: 'active',
            })
            emits.success({ message: t('schedule.deleteQuestionnaire.success') })
        },
        onError: () => {
            emits.error({ message: t('schedule.deleteQuestionnaire.error') })
            emits.close()
        }
    })
    const closeSchedule = useMutation({
        mutationFn: scheduleServiceFetch.closeSchedule,
        onSuccess: (data) => {
            if (data?.errors?.length) {
                emits.error({ message: t('schedule.closeQuestionnaire.error') })
                return
            }
            const typeName = bodySection?.typeOfQuestionnaire == TypeOfQuestionarie.BYUSER ? EventQuery.user_schedule : EventQuery.unit_schedule
            queryClient.invalidateQueries({
                queryKey: [typeName],
                type: 'active',
            })
            emits.success({ message: t('schedule.closeQuestionnaire.success') })
        },
        onError: () => { emits.error({ message: t('schedule.closeQuestionnaire.error') }) }
    })

    const visitListLeng = visitList?.length
    const deleteSheduleQuestionnaire = ({ id }: { id: string }) => {
        const schedule = visitList?.find(item => item.id == id)
        emitEvent(Events.modal, {
            open: true,
            title: t('schedule.deleteQuestionnaire.title') ?? '',
            description: t('schedule.deleteQuestionnaire.description', { name: schedule?.title, init_date: schedule?.dateStart }) ?? '',
            cancel: (payload) => {
                payload?.close()
            },
            confirm: () => {
                emits.loading({ value: true })
                deleteSchedule.mutate({ id })
            },
        })
    }

    const closeScheduleQuestionnaire = ({ id }: { id?: string }) => {
        emitEvent(Events.modal, {
            open: true,
            title: t('schedule.modal.wantClose') ?? '',
            description: t('schedule.modal.descriptionClose') ?? '',
            cancel: (payload) => {
                payload?.close()
            },
            confirm: (payload) => {
                if (id) {
                    closeSchedule.mutate(id)
                }
                payload?.close()
            },
        })
    }

    return (
        <>
            <Box sx={styles.header}>
                <Box sx={styles.space}>
                    <Typography variant="title_main" color='primary.100'>{t('schedule.detail.title')}</Typography>

                    {!!closeQuestionnaire && <LoadingButton loading={closeSchedule.isPending} onClick={() => { closeScheduleQuestionnaire({ id }) }} variant="container_error" color="error">{t('general.closeSchedule')}</LoadingButton>}
                </Box>

                <Box sx={styles.title}>
                    <Typography variant="subtitle">{t('general.title', { title: bodySection?.title || t('general.noData') })}</Typography>

                    <Typography variant="subtitle">{t('general.description', { description: bodySection?.description || t('general.noData') })}</Typography>

                    <Typography variant="subtitle">{t('general.fromTo', { from: from ?? '', to: to ?? '' })}</Typography>
                </Box>

                <Box sx={styles.up}>

                    {/* <Box>
                        <Button disabled={!reportUrl} variant="text_primary">{t('general.downloadReport')}</Button>
                    </Box> */}
                    <Hidden xlUp>
                        <ActionDrawer
                            body={(
                                <BosySecton {...bodySection} />
                            )}
                        >
                            {({ openDrawer }) => (
                                <Box >
                                    <IconButton onClick={openDrawer}><Tooltip title={'Abrir info. planificacion'}>{icons('setting')}</Tooltip></IconButton>
                                </Box>
                            )}
                        </ActionDrawer>
                    </Hidden>
                </Box>
            </Box>

            <Box sx={styles.visits}>
                {
                    visitList?.map((visit) => (
                        <Visite
                            key={visit.id}
                            seeDetail={seeDetail}
                            showchildren={visitListLeng > 1}
                            isStore={isStore}
                            children={(
                                <Tooltip
                                    title={t('general.deleteQuestionnaire')}
                                    children={
                                        <IconButton
                                            disabled={deleteSchedule.isPending}
                                            onClick={() => { deleteSheduleQuestionnaire({ id: visit.id }) }}
                                        >
                                            {icons('simple-close')}
                                        </IconButton>
                                    }
                                />
                            )}
                            {...visit}
                        />
                    ))
                }
            </Box>
        </>
    )
}

export { VisitList }